import { AppBar } from 'react-admin'
import logo from '@/assets/logo.svg'
import { tokens } from '@/Layout/theme'
import { useAuth } from '@/context/AuthContext'

export const NavBar = (props: object) => {
  const colors = tokens()
  const { logout } = useAuth()

  return (
    <AppBar
      sx={{
        '& .RaAppBar-toolbar': {
          width: '100%',
          height: '56px',
          justifyContent: 'space-between',
          backgroundColor: colors.neutral[800],
        },
      }}
      color="primary"
      {...props}
    >
      <img src={logo} alt="DigitalZone logo" style={{ marginLeft: 8, height: 32 }} />
      <div
        style={{
          width: '100%',
          display: 'flex',
          marginLeft: 0,
          alignItems: 'center',
        }}
      />
      <button
        onClick={logout}
        style={{
          color: 'white',
          border: '2px solid white',
          borderRadius: '4px',
          padding: '4px 8px',
          backgroundColor: colors.neutral[800],
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 600,
          marginRight: 8,
          transition: 'background-color 0.3s, color 0.3s',
        }}
      >
        Logout
      </button>
    </AppBar>
  )
}
